"use strict";'use strict';

var chunk7QQTAFGT_js = require('./chunk-7QQTAFGT.js');
require('./chunk-JONQEVRS.js');



module.exports = chunk7QQTAFGT_js.Star_default;
